import { render } from "./LabelGeneric.vue?vue&type=template&id=647b19da"
import script from "./LabelGeneric.vue?vue&type=script&lang=ts"
export * from "./LabelGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script